
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getCustomerType = async () => {
  return await get<ApiResponse<any[]>>("/customerType").then((res)=>{
      return res
    })
};

 